<template>
  <div id="rwt-plugin-container">
    <prevent-interaction/>
    <div class="header">
      <div class="center-el">
        <a class="logo"></a>
      </div>
    </div>
    <router-view/>
  </div>
</template>

<script>
import PreventInteraction from "./components/PreventInteraction";

export default {
    components: {PreventInteraction},
    name: 'App'
}
</script>

<style lang="scss" scoped>
  /*@import './assets/test.scss';*/
</style>



// WEBPACK FOOTER //
// src/App.vue